import module from 'nominas/nomina/module.js'

const schema = {
  conceptos: {
    id: 'number',
    impuesto_estatal: 'boolean',
    editable: 'boolean',
    orden: 'number',
    pagoExterno: 'boolean',
    porcentaje_excento: 'number',
    porcentaje_plan_de_pension: 'number',
    pagado: 'boolean',
  },
}

export default class NominasNominaCalculoConceptos {
  constructor ($http) {
    this.$http = $http
  }

  get (config) {
    return this.$http.get('/api/nominas/nomina/calculo/conceptos', {
      params: {
        id_proyecto: config.id_proyecto,
        tipo_calculo_id: config.tipo_calculo_id,
      },
      schema,
    })
  }
}

module.service('NominasNominaCalculoConceptos', NominasNominaCalculoConceptos)



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Calculo/Conceptos.js